export type AiResultHandoff = {
  source: string;
  subject?: string;
  text: string;
};

export const withAiResult = (question: string, handoff: AiResultHandoff): string => {
  const about = handoff.subject ? ` for «${handoff.subject}»` : "";
  return (
    `[Brukeren spør videre om et resultat fra KI-funksjonen «${handoff.source}»${about}. ` +
    "Svar ut fra dette resultatet, slik det står på skjermen nå, uten at brukeren må lime det inn:\n" +
    `"""\n${handoff.text.trim()}\n"""]\n\n${question}`
  );
};

const HANDOFF = /^\[Brukeren spør videre om et resultat fra KI-funksjonen «([^»]*)»(?: for «([^»]*)»)?\. [\s\S]*?\n"""\]\n\n/;

export const whatTheUserTyped = (content: string): string => {
  const handoff = HANDOFF.exec(content);
  if (!handoff) {
    return content;
  }
  const question = content.slice(handoff[0].length).trim();
  return question || [handoff[1], handoff[2]].filter(Boolean).join(" · ");
};
